export enum ExecutionActions {
  Reset = "reset",
  PostExecutionPlan = "postExecutionPlan",
  GetExecutionPlan = "getExecutionPlan",
  CertificateRequired = "certificateRequired",
}
